import lodash from "lodash";
import store from "../../../../store/index";
import { defineAsyncComponent } from "vue";
import { createLoading } from "../../../../utils/loading";
import { createPage, createRowActionPdf } from "../../../../utils/page";
import { initUseForm } from "../../../../utils/form";
import { toRaw } from "vue";
import { validateError } from "../../../../utils/validate";
import { createColumns } from "./fee-statement.section";
import i18n from "../../../../i18n";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/feeStatement";
export const callReportData = ({ data }) => store.dispatch(`${actionPrefix}/reportData`, { data });
export const callReportReceipt = ({ data }) => store.dispatch(`${actionPrefix}/reportReceipt`, { data });

export const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const initData = ({ props, data }) => {
    const { itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [];
    data.manageExtras = [];
    data.rowActions = [
        createRowActionPdf({
            bind: { class: "btn-primary", size: "small", icon: () => <CIcon file="pdf.svg"></CIcon> },
            text: () => i18n.global.t("button.viewDocument"),
            callReport: ({ record }) => callReportData({ data: { feeStatement: record } }),
            fileName: `fee_statement_${modelRef?.feeCode || "draft"}.pdf`,
            visible: ({ record }) => !!record.id
        }),
        // createRowActionOpenUrl({
        //     bind: { class: "btn-primary", size: "small", icon: () => <CIcon file="search.svg"></CIcon> },
        //     text: () => i18n.global.t("button.viewDocument"),
        //     callUrl: ({ record }) => `${process.env.VUE_APP_API_URL}/files/haz/dof/${record.id}/file-result.pdf?contentDisposition=inline`,
            // visible: ({ record }) => data.conditionAction.canReport({ props, record })
        // })
    ];
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise
        .then(page => initUseForm({ data, page }))
        .finally(() => setIsLoading(false));
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};
